import React from "react";

const BASE_WIDTH = 40;
const BASE_HEIGHT = 40;

interface OwnProps {
  width?: number;
  height?: number;
  color?: string;
}
export default function RotateLeftIcon(props: OwnProps) {
  const width = props.width || BASE_WIDTH;
  const height = props.height || BASE_HEIGHT;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 33H30C30.5303 32.9995 31.0387 32.7886 31.4136 32.4136C31.7886 32.0387 31.9995 31.5303 32 31V19C31.9995 18.4697 31.7886 17.9613 31.4136 17.5864C31.0387 17.2114 30.5303 17.0005 30 17H18C17.4697 17.0005 16.9613 17.2114 16.5864 17.5864C16.2114 17.9613 16.0005 18.4697 16 19V31C16.0005 31.5303 16.2114 32.0387 16.5864 32.4136C16.9613 32.7886 17.4697 32.9995 18 33V33ZM30 19V31H17.999L18 19H30Z"
        fill="#4D4D4D"
      />
      <path
        d="M4 18L5.41 16.59L8 19.17V14C8.00212 12.1441 8.7403 10.3649 10.0526 9.05259C11.3649 7.7403 13.1441 7.00212 15 7H20V9H15C13.6744 9.00159 12.4036 9.52888 11.4662 10.4662C10.5289 11.4036 10.0016 12.6744 10 14V19.17L12.59 16.59L14 18L9 23L4 18Z"
        fill="#4D4D4D"
      />
    </svg>
  );
}
